// extracted by mini-css-extract-plugin
export default {"container":"Side_container__4GEW2","menus":"Side_menus__Iy+O0"};